import { supabase } from './supabase';

// First-party usage telemetry (usage_events table). Page views + device only —
// business actions (creations, publishes) are derived server-side from the core
// tables' own timestamps in get_usage_stats, so nothing else needs instrumenting.

// ponytail: rough UA regex buckets, swap for ua-parser-js if precision ever matters
const ua = navigator.userAgent;
const device = /iPad|Tablet/i.test(ua) ? 'tablet' : /Mobi|Android|iPhone/i.test(ua) ? 'mobile' : 'desktop';
const os = /iPhone|iPad|iPod/.test(ua) ? 'iOS'
  : /Android/.test(ua) ? 'Android'
  : /Windows/.test(ua) ? 'Windows'
  : /Mac/.test(ua) ? 'macOS'
  : /Linux/.test(ua) ? 'Linux' : 'Otro';
const browser = /Edg\//.test(ua) ? 'Edge'
  : /OPR\//.test(ua) ? 'Opera'
  : /Chrome\//.test(ua) ? 'Chrome'
  : /Firefox\//.test(ua) ? 'Firefox'
  : /Safari\//.test(ua) ? 'Safari' : 'Otro';

// Collapse ids so /propiedades/123 and /propiedades/abc-uuid count as one page.
const normalizePath = (path: string) =>
  path.replace(/\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi, '/:id')
      .replace(/\/\d+(?=\/|$)/g, '/:id');

let lastPath = '';

/** Fire-and-forget page-view log. Telemetry must never surface errors to the user. */
export function trackPageView(pathname: string): void {
  const path = normalizePath(pathname);
  if (path === lastPath) return;
  lastPath = path;
  supabase.from('usage_events')
    .insert({ platform: 'web', path, device, os, browser })
    .then(() => {}, () => {});
}

/** Fire-and-forget custom event (e.g. 'ai_trial_start') at the current page. */
export function trackEvent(event: string): void {
  supabase.from('usage_events')
    .insert({ platform: 'web', event, path: normalizePath(window.location.pathname), device, os, browser })
    .then(() => {}, () => {});
}
